import { styleConstants } from '@paywithextend/components'
import React from 'react'
import Tooltip from 'src/components/Tooltip/Tooltip'
import Trns from 'src/localization/Trns'
import { css } from 'styled-components'

const CustomerSupportCodeTooltip = (): React.ReactElement => (
  <Tooltip openLeft={false}>
    <Trns
      source={
        '${supportCode} is a one-time, 6-digit security code that helps customer service verify that you are the owner of the virtual card.'
      }
      expressions={{
        supportCode: (
          <span
            css={css`
              font-family: ${styleConstants.fontFamilies.medium};
            `}
          >
            <Trns source={'Customer support code'} />
          </span>
        ),
      }}
    />
  </Tooltip>
)

export default CustomerSupportCodeTooltip
